import { render, staticRenderFns } from "./Requirements.vue?vue&type=template&id=99178962&"
import script from "./Requirements.vue?vue&type=script&lang=js&"
export * from "./Requirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports